import React, { useState } from 'react'

export const OrderMarkContext = React.createContext()

export function OrderMarkContextProvider (props) {
  const [pid, setPid] = useState('') // 医院编号
  const [position, setPosition] = useState('') // 床位号
  const [orderDateList, setOrderDateList] = useState([]) // 可点餐的日期数组
  const [outHospitalTime, setOutHospitalTime] = useState('')
  const [foodAdvice, setFoodAdvice] = useState('') // 饮食医嘱
  const [patientName, setPatientName] = useState('') // 病人的姓名
  const [mealtypes, setMealtypes] = useState([]) // 营养套餐的食物餐次比如早餐、早点等等
  const [yyFoodType, setYyFoodType] = useState([]) // 营养套餐的所有食物类型
  const [xgFoodType, setXgFoodType] = useState([]) // 小锅菜系的所有食物类型
  const [properties, setProperties] = useState() // 该医院的配置（是否支持包伙制）
  const [allYyFoodMark, setAllYyFoodMark] = useState('') // 营养餐的全部当前餐次所点份数
  const [allXgFoodMark, setAllXgFoodMark] = useState('') // 小锅菜的全部当前餐次所点份数
  const [ossClient, setOssClient] = useState('') // OSS帐号授权
  return (
    <OrderMarkContext.Provider
      value={{
        pid: pid,
        setPid: setPid,
        position: position,
        setPosition: setPosition,
        orderDateList: orderDateList,
        setOrderDateList: setOrderDateList,
        outHospitalTime: outHospitalTime,
        setOutHospitalTime: setOutHospitalTime,
        foodAdvice: foodAdvice,
        patientName: patientName,
        setPatientName: setPatientName,
        setFoodAdvice: setFoodAdvice,
        yyFoodType: yyFoodType,
        setYyFoodType: setYyFoodType,
        xgFoodType: xgFoodType,
        setXgFoodType: setXgFoodType,
        mealtypes: mealtypes,
        setMealtypes: setMealtypes,
        properties: properties,
        setProperties: setProperties,
        allYyFoodMark: allYyFoodMark,
        setAllYyFoodMark: setAllYyFoodMark,
        allXgFoodMark: allXgFoodMark,
        setAllXgFoodMark: setAllXgFoodMark,
        ossClient: ossClient,
        setOssClient: setOssClient
      }}
    >
      {props.children}
    </OrderMarkContext.Provider>
  )
}
